import React, { Component } from 'react';
// import { PrismCode } from 'react-prism';
import { Player, ControlBar } from 'video-react';
import { Button } from 'reactstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios';

import "../../../node_modules/video-react/dist/video-react.css";
import "./dataset.css"

const config = require('../../config').get(process.env.REACT_APP_ENVIRONMENT);

export default class PlayerControlExample extends Component {
  url = "https://test-users.dev.fitvdev.com"
  jsonObj = {
    meta: 
    {
        videoName: '', 
        fps: '', 
        width: '', 
        height: ''
    }, 
    events: {}, 
    pid: '', 
    view: '', 
    className: ''
  }
 
  initState = {
    _id: '',
    name: null,
    source: '',
    startTime: null,
    endTime: null,
    events:  [],
    playbackRate: 0.75
  }
  
  constructor(props, context) {
    super(props, context);

    this.state = {
      ...this.initState,
      unlabeledSamples: [],
      newLablesSample: [],
      open: false,
      openNewSampleDropDown: false,
      openError:false
    };

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.changePlaybackRateRate = this.changePlaybackRateRate.bind(this);
    this.saveLableing = this.saveLableing.bind(this);
    this.keyDown = this.keyDown.bind(this)
    this.changeSource = this.changeSource.bind(this)
    this.initVariables = this.initVariables.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.sendMail = this.sendMail.bind(this)
  }

  componentWillMount = () => {
    this.getUnlabeledSamples()
  }

  componentDidMount() {
    // subscribe state change
    document.addEventListener("keydown", this.keyDown, false);
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.keyDown, false);
  }

  keyDown(env) {
    // p-80 s-83 e -69 arrow-left-37 arrow-right-39 arrowDown-40 d-68 q - 81
    switch (env.keyCode) {
      case 80:
        if(this.state.player && this.state.player.paused) {
          this.play()
        } else if (this.state.player) {
          this.pause()
        }
        break;
      case 83:
        if(this.state.player && this.state.player.currentTime) {
          let eventLength = this.state.events.length;
          if(eventLength === 0 || (eventLength > 0 && this.state.player.currentTime > this.state.events[eventLength - 1].window[1])) {
            this.setState({
              startTime: this.state.player.currentTime - 0.1
            })
          }
        }
        break;
      case 69:
        if(this.state.startTime && this.state.player && this.state.player.currentTime) {
          this.pause()
          this.setState({
            endTime: this.state.player.currentTime
          })
        }
        break;
      case 85:
        if (this.state.endTime && this.state.startTime && this.state.endTime >= this.state.startTime) {
          this.play()
          this.setState({
            events: [...this.state.events, {window: [this.state.startTime, this.state.endTime], type: 'LEFT'}],
            startTime: this.state.endTime + 0.1,
            endTime: null
          })
        }
        break;
      case 79:
        if (this.state.endTime && this.state.startTime && this.state.endTime >= this.state.startTime) {
          this.play()
          this.setState({
            events: [...this.state.events, {window: [this.state.startTime, this.state.endTime], type: 'RIGHT'}],
            startTime: this.state.endTime + 0.1,
            endTime: null
          })
        }
        break;
      case 73:
        this.play()
        if (this.state.endTime && this.state.startTime && this.state.endTime >= this.state.startTime) {
          this.setState({
            events: [...this.state.events, {window: [this.state.startTime, this.state.endTime], type: 'NONE'}],
            startTime: this.state.endTime + 0.1,
            endTime: null
          })
        }
        break;
      case 68:
        let events = this.state.events
        events.pop()
        this.setState({
          events: events,
          startTime: null,
          endTime: null
        })
        break;
      case 81:
        this.pause()
        this.setState({
          open: true
        })
        break;
      default:
        break;
    }
  }

  getUnlabeledSamples() {
    axios.get(`${this.url}/getUnlabeledSamples`)
    .then(res => {
      this.setState({
        ...this.state,
        unlabeledSamples: res.data.data
      })
    })
    .catch(err => {
      console.log("error", err);
      sendCreatePlanErrorToSlack(err)
    })
  }
  
  saveLableing = async() => {
    let date = this.dateFormatting();
    this.jsonObj.events[date] = this.state.events

    try {
      let res = await axios.put(`${this.url}/${this.state._id}/updateActionLabelsById`, this.jsonObj)

      console.log(res);

      let unlabeledSamples = this.state.unlabeledSamples.filter(unlabeld => unlabeld._id !== this.state._id)
      this.setState({
        unlabeledSamples: unlabeledSamples,
        newLablesSample: [...this.state.newLablesSample, this.state.name],
        ...this.initState
      })
    } catch (error) {
      sendCreatePlanErrorToSlack(error)
      this.setState({openError: true})
      this.initVariables()
    }
  }

  initVariables() {
    this.setState({
      ...this.initState
    })
    this.jsonObj = {
      meta: 
      {
          videoName: '', 
          fps: '', 
          width: '', 
          height: ''
      }, 
      events: {}, 
      pid: '', 
      view: '', 
      className: ''
    }
  }

  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({
      player: state
    });
  }

  play() {
    this.player.play();
  }

  pause() {
    this.player.pause();
  }

  changePlaybackRateRate(env) {
    this.setState({
      playbackRate: env.target.value
    })
    this.player.playbackRate = parseFloat(env.target.value) ;
  }

  changeSource = async (env) => {
    this.dateFormatting()
    this.initVariables()
    this.player.playbackRate = parseFloat(0.75);
    
    let id = env.target.value
    let unlabledDetails = this.state.unlabeledSamples.find(unlabled => unlabled._id === id)
    
    if(unlabledDetails && unlabledDetails.videoKey) {
      
      let response = await axios.get(`${this.url}/${id}/getSampleData`);

      if (!response) return
      response = response.data.data
      let metaData = await axios.post(`${config.URL}/api/utils/videomatadata`, { url: response.sampleVideoUrl })

      if(!metaData) return 

      this.setState({
        _id: id,
        source: response.sampleVideoUrl
      });
      this.player.load();

      this.setState({
        name: unlabledDetails.videoKey
      })


      unlabledDetails = unlabledDetails.videoKey.split('/')
      this.jsonObj.meta = {
        videoName: unlabledDetails[unlabledDetails.length - 1],
        fps: metaData.data.fps,
        width: metaData.data.width,
        height: metaData.data.height
      }
      this.jsonObj.events = response.actionLabels && response.actionLabels.events ? response.actionLabels.events : {}
      this.jsonObj.pid = unlabledDetails[unlabledDetails.length - 2]
      this.jsonObj.view = unlabledDetails[unlabledDetails.length - 3]
      this.jsonObj.className = unlabledDetails[unlabledDetails.length - 4]
    }
  }

  dateFormatting() {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0');
    let MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear()
    let hh = today.getHours()
    let mm = today.getMinutes()

    if(hh.toString().length === 1) hh = '0' + hh.toString()
    if(mm.toString().length === 1) mm = '0' + mm.toString()
    return yyyy+MM+dd+hh+mm
  }

  renderSelect = (options) => (
    options.map((unlabled, i) => {
      return <option key={i} value={unlabled._id}> { unlabled.videoKey} </option>
    })
  )

  renderSavedSelect = (options) => (
    options.map((item, i) => {
      return <option key={i} value={item}> {item} </option>
    })
  )

  handleClose = (response) => {
    if(response) {
      this.saveLableing()
    } else {
      this.initVariables()
    }
    this.player.load();
    document.getElementById("select-ds").selectedIndex=0
    this.setState({
      open: false
    })
  };

  sendMail = () => {
    let names = '';
    this.state.newLablesSample.forEach(name => {
      names += name + '\n'
    })
    axios.post(`${config.URL}/api/utils/mail`, { address: "ofer.g@fitv.ai", subject: "New Labled Samples", text: names })
      .then(req => {
        console.log('mail send');
        this.setState({
          newLablesSample: []
        })
      })
      .catch(error => {
        sendCreatePlanErrorToSlack(error)
      })
  }

  render() {
    return (
      <div className="inline">
        <div className="dataset-right-dev">
          <div style={{ marginBottom: "7vh" }}>
            <p style={{marginBottom: 0}}> Unlabled Data Sample</p>
            <select className="select-motivation input-motivation"  name="unlabeledSamples" type="text" id="select-ds"
                 onChange={this.changeSource} disabled={this.state.player ? !this.state.player.paused : false}>
                <option>Select Data Sample</option>
                {this.renderSelect(this.state.unlabeledSamples)}
            </select>
          </div>
          <div className="inline">
            <div className="dataset-instructions-dev">
            <p> Instructions</p>
            <span style={{ whiteSpace: "pre-wrap", width: '50%'}}> 
              p - play/pause <br></br>
              s - mark start event<br></br>
              e - mark end event <br></br>
              u - mark left side<br></br>
              i - mark none side<br></br>
              o - mark right side<br></br>
              d - delete last event<br></br>
              q - quit and save job<br></br>
              </span>
            </div>
            <div className="pb-3">
              <p>Playback Speed</p>
              <select className="select-motivation select-datasetVideoPlayback" type="text"
                 onChange={this.changePlaybackRateRate} value={this.state.playbackRate}>
                  <option value="1">Select Speed</option>
                  <option value="0.2">x0.2</option>
                  <option value="0.3">x0.3</option>
                  <option value="0.4">x0.4</option>
                  <option value="0.5">x0.5</option>
                  <option value="0.75">x0.75</option>
                  <option value="1.0">x1.0</option>
              </select>
            </div>
          </div>
          <div className="dataset-right-bottom-div">
            <p style={{marginBottom: 0}}>Saved Data Sample</p>
            <select className="select-motivation input-motivation"  name="newSamples" type="text" 
                onChange={() => {}} disabled={this.state.player ? !this.state.player.paused : false}>
                <option>Select Data Sample</option>
                {this.renderSavedSelect(this.state.newLablesSample)}
            </select>
            <Button onClick={this.sendMail} className="mr-3" style={{marginLeft: '1vw'}}>
            Export list
          </Button>
          </div>
        </div>
        <div className="video-div-right">
        <Player
          ref={player => {
            this.player = player;
          }}
          muted={true}
          fluid={false}
          width={600}
          height={600}
        >
          <source src={this.state.source} />
          <ControlBar autoHide={false} />
        </Player>
        <div>
          <p>{this.state.name}</p>
        </div>
        <div className="py-3">
          <Button onClick={this.play} className="mr-3">
            play()
          </Button>
          <Button onClick={this.pause} className="mr-3">
            pause()
          </Button>
        </div>
        </div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Are you sure you want to save data labling ?"}</DialogTitle>
          <DialogContent>
            {/* <DialogContentText id="alert-dialog-description"> */}
            <pre id="json">{ JSON.stringify(this.state.events, null, 2) }</pre>
            {/* </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose(false)} color="primary">
              Disagree
            </Button>
            <Button onClick={() => this.handleClose(true)} color="primary" autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.openError}
          onClose={() => { this.setState({openError: false})}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Error saving lables"}</DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { this.setState({openError: false})}} color="primary" autoFocus>
                close
              </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}


const sendCreatePlanErrorToSlack = (error) => {
  let slackUrl = 'https://hooks.slack.com/services/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';
  try {
      axios.post(
        slackUrl,
        { "text": `DataSample client => error:${JSON.stringify(error)}`}
      )
  } catch (error) {
    console.log("Error log was not sent to Slack");
  }
};